module.exports = "<div class=\"feedback-wrapper\" style=\"height: 350px;\">\n  <!-- <ng-flutter assetBase=\"/assets/flutter_modernization/web/\"\n    (appLoaded)=\"onFlutterAppLoaded($event)\">\n  </ng-flutter> -->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/feedback/feedback.component.html
// module id = ../../../../../src/app/layout/home/feedback/feedback.component.html
// module chunks = main